module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_pp23_8004.d1b2fe20.png";